export default __webpack_public_path__ + "static/media/asistencia-contribuyente.ac341c52.svg";